import React from 'react'

const IndexPage = () => (
  <div>
    <p>Pour toute information, vous pouvez contacter le syndic <a href="http://www.regievincenttarge.com/">Régie Vincent Targe</a>.</p>
    <p>Vous pouvez aussi envoyer un mail au conseil syndical : <a href="mailto:conseil@residence-le15.fr">conseil@residence-le15.fr</a>.</p>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js